import { Divider, Flex, Skeleton } from '@chakra-ui/react';

const MemberLoadingCell = () => {
  return (
    <>
      <Flex
        direction={'column'}
        gap={4}
        p={4}
        bg="white"
        minH={'184px'}
        w="149px"
        borderLeft="1px solid #E0E0E0"
      >
        <Skeleton height="24px" width="96px" />
        <Skeleton height="24px" width="96px" />
        <Skeleton height="24px" width="96px" />
      </Flex>
      <Divider />
    </>
  );
};

export default MemberLoadingCell;
